import React from "react";
import { Box, TextField, useTheme } from "@mui/material";

export interface AIGradientTextFieldProps {
  hideGradient?: boolean;
  fillContainer?: boolean;

  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;

  submitOnEnter?: boolean;
  onSubmit?: () => void;

  actions?: React.ReactNode;
}

export default function AIGradientTextField(props: AIGradientTextFieldProps) {
  const theme = useTheme();

  let styles = {
    position: "relative",
    borderRadius: "10px",
    background: theme.colors.namedColors.aiGradient,
    backgroundSize: "400% 400%",
    animation: theme.colors.namedColors.aiAnimation,
    p: "2px",
    "@keyframes border-shimmer": {
      "0%": { backgroundPosition: "0% 0%" },
      "50%": { backgroundPosition: "100% 100%" },
      "100%": { backgroundPosition: "0% 0%" },
    }
  };

  const fixedContainer = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };

  if (props.fillContainer) {
    styles = props.hideGradient ? {...fixedContainer} : { ...styles, ...fixedContainer };
  } else if (props.hideGradient) {
    styles = { ...styles, background: theme.colors.namedColors.chart1 };
  }

  const innerStyles = {
    borderRadius: "8px",
    backgroundColor: theme.palette.background.paper,
  };

  if (props.actions) {
    innerStyles["display"] = "grid";
    innerStyles["gridTemplateColumns"] = "1fr auto";
    innerStyles["alignItems"] = "center";
    innerStyles["gap"] = "0";
  }

  return (
    // Animated gradient border around the box
    <Box sx={styles}>
      <Box sx={innerStyles}>
        <TextField
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                border: "none",
                "&:hover": {
                  border: "none"
                }
              }}}
            fullWidth
            multiline
            autoComplete="off"
            minRows={1}
            autoFocus={true}
            variant="outlined"
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            focused
            onKeyDown={(e) => {
              if (props.submitOnEnter && e.key === "Enter") {
                e.preventDefault();
                props.onSubmit?.();
              }
            }}
          />
        {props.actions && (
          <Box>
            {props.actions}
          </Box>
        )}
      </Box>
    </Box>
  );
}